import React, { Component } from 'react';

import Page from '../page';
import Request from '../request';

export default class extends Component {

    render() {

        return (
            <Page {...this.props}>
                <Request />
            </Page>
        );
    }
};
